module.exports = __webpack_public_path__ + "img/pauseicon.e06c8a58.svg";